import { render } from "./YouthModeBanner.vue?vue&type=template&id=1ce5a6d1&scoped=true"
import script from "./YouthModeBanner.vue?vue&type=script&lang=js"
export * from "./YouthModeBanner.vue?vue&type=script&lang=js"

import "./YouthModeBanner.vue?vue&type=style&index=0&id=1ce5a6d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce5a6d1"]])

export default __exports__